<template>
  <md-outlined-button
    v-if="props.outline"
    :disabled="props.disabled"
    :type="props.type"
    @click="emit('click')">
    {{ props.label }}
    <slot name="icon"> </slot>
  </md-outlined-button>
  <md-filled-tonal-button
    v-if="!props.outline"
    :disabled="props.disabled"
    :type="props.type"
    @click="emit('click')">
    {{ props.label }}
    <slot name="icon"> </slot>
  </md-filled-tonal-button>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  (event: 'click'): void;
}>();

const props = withDefaults(
  defineProps<{
    outline?: boolean;
    label: string;
    disabled?: boolean;
    type?: HTMLButtonElement['type'];
  }>(),
  {
    disabled: false,
    outline: false,
    type: 'button',
  }
);
</script>
